import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricCard } from "@/components/dashboard/MetricCard";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { useVersion } from "@/hooks/queries/useSystemInfo";
import { useBrokerList } from "@/hooks/queries/useBrokerStatus";

interface VersionPayload {
  data: { application_version: string };
}

interface BrokerSummary {
  name: string;
}

/** Reuses Sprint 3.1/3.2's `useVersion` and `useBrokerList` hooks rather than duplicating them. */
export function PortfolioSystemInformationSection(): React.JSX.Element {
  const versionQuery = useVersion();
  const brokersQuery = useBrokerList();

  return (
    <StatusCard title="System Information">
      <Stack spacing={1.5}>
        <QueryStateBoundary query={versionQuery}>
          {(payload) => (
            <MetricCard
              label="Backend Version"
              value={(payload as unknown as VersionPayload).data?.application_version}
            />
          )}
        </QueryStateBoundary>
        {/* No backend endpoint versions the Portfolio module distinctly from the overall backend release. */}
        <MetricCard label="Portfolio Version" value={null} />
        <QueryStateBoundary
          query={brokersQuery}
          isEmpty={(data) => (data as unknown as BrokerSummary[]).length === 0}
          emptyMessage="No broker providers are configured."
        >
          {(payload) => (
            <MetricCard
              label="Provider"
              value={(payload as unknown as BrokerSummary[]).map((b) => b.name).join(", ")}
            />
          )}
        </QueryStateBoundary>
        {/* SyncStatusDto carries no timestamp field today. */}
        <MetricCard label="Last Synchronization" value={null} />
      </Stack>
    </StatusCard>
  );
}
